// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { EntityDetail_DeathOrderNoteFragment, EntityDetail_EntityFragment } from '../../../details/graphql/EntityDetailPage.generated';
import { gql } from '@apollo/client';
import { EntityDetail_DeathOrderNoteFragmentDoc, EntityDetail_EntityFragmentDoc } from '../../../details/graphql/EntityDetailPage.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GenerateEntityNotesFromDocumentSummaryMutationVariables = Types.Exact<{
  input: Types.CreateEntityNotesFromDocumentSummaryInput;
}>;


export type GenerateEntityNotesFromDocumentSummaryMutation = { __typename?: 'Mutation', generateEntityNotesFromDocumentSummary: Array<(
    { __typename?: 'EntityNotes' }
    & EntityDetail_DeathOrderNoteFragment
  )> };

export type SyncDeathOrderNotesMutationVariables = Types.Exact<{
  input: Types.SyncDeathOrderNotesInput;
}>;


export type SyncDeathOrderNotesMutation = { __typename?: 'Mutation', syncDeathOrderNotes: (
    { __typename?: 'Entity' }
    & EntityDetail_EntityFragment
  ) };

export const Operations = {
  Mutation: {
    GenerateEntityNotesFromDocumentSummary: 'GenerateEntityNotesFromDocumentSummary' as const,
    SyncDeathOrderNotes: 'SyncDeathOrderNotes' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const GenerateEntityNotesFromDocumentSummaryDocument = gql`
    mutation GenerateEntityNotesFromDocumentSummary($input: CreateEntityNotesFromDocumentSummaryInput!) {
  generateEntityNotesFromDocumentSummary(input: $input) {
    ...EntityDetail_DeathOrderNote
  }
}
    ${EntityDetail_DeathOrderNoteFragmentDoc}`;
export type GenerateEntityNotesFromDocumentSummaryMutationFn = Apollo.MutationFunction<GenerateEntityNotesFromDocumentSummaryMutation, GenerateEntityNotesFromDocumentSummaryMutationVariables>;

/**
 * __useGenerateEntityNotesFromDocumentSummaryMutation__
 *
 * To run a mutation, you first call `useGenerateEntityNotesFromDocumentSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateEntityNotesFromDocumentSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateEntityNotesFromDocumentSummaryMutation, { data, loading, error }] = useGenerateEntityNotesFromDocumentSummaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateEntityNotesFromDocumentSummaryMutation(baseOptions?: Apollo.MutationHookOptions<GenerateEntityNotesFromDocumentSummaryMutation, GenerateEntityNotesFromDocumentSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateEntityNotesFromDocumentSummaryMutation, GenerateEntityNotesFromDocumentSummaryMutationVariables>(GenerateEntityNotesFromDocumentSummaryDocument, options);
      }
export type GenerateEntityNotesFromDocumentSummaryMutationHookResult = ReturnType<typeof useGenerateEntityNotesFromDocumentSummaryMutation>;
export type GenerateEntityNotesFromDocumentSummaryMutationResult = Apollo.MutationResult<GenerateEntityNotesFromDocumentSummaryMutation>;
export type GenerateEntityNotesFromDocumentSummaryMutationOptions = Apollo.BaseMutationOptions<GenerateEntityNotesFromDocumentSummaryMutation, GenerateEntityNotesFromDocumentSummaryMutationVariables>;
export const SyncDeathOrderNotesDocument = gql`
    mutation SyncDeathOrderNotes($input: SyncDeathOrderNotesInput!) {
  syncDeathOrderNotes(input: $input) {
    ...EntityDetail_Entity
  }
}
    ${EntityDetail_EntityFragmentDoc}`;
export type SyncDeathOrderNotesMutationFn = Apollo.MutationFunction<SyncDeathOrderNotesMutation, SyncDeathOrderNotesMutationVariables>;

/**
 * __useSyncDeathOrderNotesMutation__
 *
 * To run a mutation, you first call `useSyncDeathOrderNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncDeathOrderNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncDeathOrderNotesMutation, { data, loading, error }] = useSyncDeathOrderNotesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncDeathOrderNotesMutation(baseOptions?: Apollo.MutationHookOptions<SyncDeathOrderNotesMutation, SyncDeathOrderNotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncDeathOrderNotesMutation, SyncDeathOrderNotesMutationVariables>(SyncDeathOrderNotesDocument, options);
      }
export type SyncDeathOrderNotesMutationHookResult = ReturnType<typeof useSyncDeathOrderNotesMutation>;
export type SyncDeathOrderNotesMutationResult = Apollo.MutationResult<SyncDeathOrderNotesMutation>;
export type SyncDeathOrderNotesMutationOptions = Apollo.BaseMutationOptions<SyncDeathOrderNotesMutation, SyncDeathOrderNotesMutationVariables>;